import * as React from "react";
import type { VariantProps } from 'class-variance-authority';
import { cn } from "../../lib/utils";
import { cva } from 'class-variance-authority';

const alertVariants = cva(
    "jobsite:relative jobsite:w-full jobsite:rounded-lg jobsite:border jobsite:px-4 jobsite:py-3 jobsite:text-sm jobsite:grid jobsite:has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] jobsite:grid-cols-[0_1fr] jobsite:has-[>svg]:gap-x-3 jobsite:gap-y-0.5 jobsite:items-start jobsite:[&>svg]:size-4 jobsite:[&>svg]:translate-y-0.5 jobsite:[&>svg]:text-current",
    {
      defaultVariants: {
        variant: "default",
      },
      variants: {
        variant: {
          default: "jobsite:bg-card jobsite:text-card-foreground",
          destructive:
            "jobsite:text-destructive jobsite:bg-card jobsite:[&>svg]:text-current jobsite:*:data-[slot=alert-description]:text-destructive/90",
        },
      },
    },
  ),

  Alert = ({
    className,
    variant,
    ...props
  }: React.ComponentProps<"div"> & VariantProps<typeof alertVariants>) => (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  ),

  AlertTitle = ({ className, ...props }: React.ComponentProps<"div">) => (
    <div
      data-slot="alert-title"
      className={cn(
        "jobsite:col-start-2 jobsite:line-clamp-1 jobsite:min-h-4 jobsite:font-medium jobsite:tracking-tight",
        className,
      )}
      {...props}
    />
  ),

  AlertDescription = ({ className, ...props }: React.ComponentProps<"div">) => (
    <div
      data-slot="alert-description"
      className={cn(
        "jobsite:text-muted-foreground jobsite:col-start-2 jobsite:grid jobsite:justify-items-start jobsite:gap-1 jobsite:text-sm jobsite:[&_p]:leading-relaxed",
        className,
      )}
      {...props}
    />
  );

export { Alert, AlertTitle, AlertDescription };
